var move = function move(arr, fromIndex, toIndex) {
  // console.log("from key", arr[fromIndex]);
  // console.log("to key", arr[toIndex]);
  var element = arr[fromIndex];
  arr.splice(fromIndex, 1);
  arr.splice(toIndex, 0, element);
  return arr;
};

export { move };